import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateDataObjectThumbnailsMutationVariables = Types.Exact<{
  dataObjectId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  dataObjectLegacyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  options?: Types.InputMaybe<Types.ThumbnailOptionsInput>;
  organizationId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type CreateDataObjectThumbnailsMutation = { __typename: 'Mutation', createDataObjectThumbnails: { __typename: 'Job', id: string } };

export type CreateTypedDataObjectSetThumbnailsMutationVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  options?: Types.InputMaybe<Types.ThumbnailOptionsInput>;
  organizationId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  typedDataObjectSet: Array<Types.TypedDataObjectInput> | Types.TypedDataObjectInput;
}>;


export type CreateTypedDataObjectSetThumbnailsMutation = { __typename: 'Mutation', createTypedDataObjectSetThumbnails: { __typename: 'Job', id: string } };

export type CreateTextureSetRevisionThumbnailsMutationVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  options?: Types.InputMaybe<Types.ThumbnailOptionsInput>;
  organizationId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  textureSetRevisionId: Types.Scalars['ID']['input'];
}>;


export type CreateTextureSetRevisionThumbnailsMutation = { __typename: 'Mutation', createTextureSetRevisionThumbnails: { __typename: 'Job', id: string } };

export const CreateDataObjectThumbnailsDocument = gql`
    mutation createDataObjectThumbnails($dataObjectId: ID, $dataObjectLegacyId: Int, $name: String, $options: ThumbnailOptionsInput, $organizationId: ID) {
  createDataObjectThumbnails(
    dataObjectId: $dataObjectId
    dataObjectLegacyId: $dataObjectLegacyId
    name: $name
    options: $options
    organizationId: $organizationId
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDataObjectThumbnailsGQL extends Apollo.Mutation<CreateDataObjectThumbnailsMutation, CreateDataObjectThumbnailsMutationVariables> {
    override document = CreateDataObjectThumbnailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTypedDataObjectSetThumbnailsDocument = gql`
    mutation createTypedDataObjectSetThumbnails($name: String, $options: ThumbnailOptionsInput, $organizationId: ID, $typedDataObjectSet: [TypedDataObjectInput!]!) {
  createTypedDataObjectSetThumbnails(
    name: $name
    options: $options
    organizationId: $organizationId
    typedDataObjectSet: $typedDataObjectSet
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTypedDataObjectSetThumbnailsGQL extends Apollo.Mutation<CreateTypedDataObjectSetThumbnailsMutation, CreateTypedDataObjectSetThumbnailsMutationVariables> {
    override document = CreateTypedDataObjectSetThumbnailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTextureSetRevisionThumbnailsDocument = gql`
    mutation createTextureSetRevisionThumbnails($name: String, $options: ThumbnailOptionsInput, $organizationId: ID, $textureSetRevisionId: ID!) {
  createTextureSetRevisionThumbnails(
    name: $name
    options: $options
    organizationId: $organizationId
    textureSetRevisionId: $textureSetRevisionId
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTextureSetRevisionThumbnailsGQL extends Apollo.Mutation<CreateTextureSetRevisionThumbnailsMutation, CreateTextureSetRevisionThumbnailsMutationVariables> {
    override document = CreateTextureSetRevisionThumbnailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }